import distanceCourseDetailsLocale from './en.json'

const en = {
  distanceCourseDetails: distanceCourseDetailsLocale,
}

export default en
